// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2mgYv","location":"Header_location__100Lt"};